import React, { useRef, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import styles from './HeaderSearchBar.module.css';
import SearchIcon from '@material-ui/icons/Search';
import { MdClose } from 'react-icons/md';

const HeaderSearchBar = ({
  value,
  handleChange,
  clearData,
  title,
  iconProps,
  ...props
}) => {
  const [isInputActive, setIsInputActive] = useState(false);
  const inputRef = useRef(null);

  const activateSearchInput = () => {
    setIsInputActive(true);
    setTimeout(() => inputRef.current.focus(), 100);
  };
  const closeSearchInput = () => {
    clearData();
    setIsInputActive(false);
  };

  const iconClassNames = clsx(
    styles.searchIcon,
    iconProps && iconProps.className,
  );

  return (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
      <div
        className={clsx(
          styles.srTitle,
          isInputActive && styles.srTitleInactive,
        )}
      >
        {title}
      </div>
      <div className={styles.srForm}>
        <div className={styles.lft}>
          <input
            ref={inputRef}
            className={clsx(
              styles.expandingSearch,
              isInputActive && styles.expandingSearchActive,
            )}
            type="text"
            value={value}
            onChange={handleChange}
            {...props}
          />
        </div>
        <div className={styles.rgt}>
          {isInputActive ? (
            <MdClose
              className={iconClassNames}
              onClick={() => closeSearchInput()}
            />
          ) : (
            <SearchIcon
              className={iconClassNames}
              onClick={() => activateSearchInput()}
            />
          )}
        </div>
      </div>
    </div>
  );
};

HeaderSearchBar.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  handleChange: PropTypes.func.isRequired,
  clearData: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  iconProps: PropTypes.shape({
    className: PropTypes.string,
  }),
};

export default HeaderSearchBar;
